import { translations } from '../translations'

// ? TODO: missing locate here
export const ModalSetup = modalType => {
  return {
    validate: () => {
      const modalTypes = [
        'RESCHEDULE_DATE',
        'SCHEDULE_PERIOD',
        'DELIVERED',
        'TO_REVERT',
        'ON_EXPEDITION',
        'INCIDENCE',
        'EDIT_REGISTRATION',
        'VEHICLE_REGISTRATION',
        'ADD_DRIVER',
        'RESCHEDULE_DATE_TIME',
        'SHOW_UPLOAD_POD'
      ]

      return modalTypes.includes(modalType)
    },
    contentSkeleton: () => {
      const skeleton = {
        'RESCHEDULE_DATE': {
          header: {
            icon: 'calendar',
            title: translations.pt_PT.ModalActions.modalTitleReschedule
          },
          footer: {
            left: {
              cancelBtn: true
            },
            right: {
              rescheduleBtn: true
            }
          }
        },
        'SCHEDULE_PERIOD': {
          header: {
            icon: 'clock-outline',
            title: translations.pt_PT.ModalActions.modalTitlePeriod
          },
          footer: {
            left: {
              cancelBtn: true
            },
            right: {
              scheduleBtn: true
            }
          }
        },
        'DELIVERED': {
          header: {
            icon: 'flag-outline',
            title: translations.pt_PT.ModalActions.modalTitleDelivery
          },
          footer: {
            left: {
              cancelBtn: true
            },
            right: {
              confirmBtn: true
            }
          }
        },
        'TO_REVERT': {
          header: {
            icon: 'history',
            title: translations.pt_PT.ModalActions.modalTitleRestore
          },
          footer: {
            left: {
              cancelBtn: true
            },
            right: {
              restoreBtn: true
            }
          }
        },
        'ON_EXPEDITION': {
          header: {
            icon: 'check-outline',
            title: translations.pt_PT.ModalActions.modalTitleCollected
          },
          footer: {
            left: {
              cancelBtn: true
            },
            right: {
              collectedBtn: true
            }
          }
        },
        'INCIDENCE': {
          header: {
            icon: 'alert-outline',
            title: translations.pt_PT.ModalActions.modalTitleIncidence
          },
          footer: {
            left: {
              cancelBtn: true
            },
            right: {
              reportBtn: true
            }
          }
        },
        'EDIT_REGISTRATION': {
          header: {
            icon: 'pencil-outline',
            title: translations.pt_PT.ModalActions.modalTitleEditRegistration
          },
          footer: {
            left: {
              cancelBtn: true
            },
            right: {
              editRegistrationBtn: true
            }
          }
        },
        'VEHICLE_REGISTRATION': {
          header: {
            icon: 'truck',
            title: translations.pt_PT.ModalActions.modalTitleRegistration
          },
          footer: {
            left: {
              cancelBtn: true
            },
            right: {
              registrationBtn: true
            }
          }
        },
        'ADD_DRIVER': {
          header: {
            icon: 'account-badge-outline',
            title: translations.pt_PT.ModalActions.modalTitleAddDriver
          },
          footer: {
            left: {
              cancelBtn: true
            },
            right: {
              addDriverBtn: true
            }
          }
        },
        'RESCHEDULE_DATE_TIME': {
          header: {
            icon: 'calendar-clock',
            title: translations.pt_PT.ModalActions.modalTitleCollect
          },
          footer: {
            left: {
              cancelBtn: true
            },
            right: {
              rescheduleDateTimeBtn: true
            }
          }
        },
        'SHOW_UPLOAD_POD': {
          header: {
            icon: 'sticker-plus-outline',
            title: translations.pt_PT.ModalActions.modalTitleUploadPod
          },
          footer: {
            left: {
              cancelBtn: true
            },
            right: {
              showUploadBtn: true
            }
          }
        }
      }

      return skeleton[modalType]
    }
  }
}



// WEBPACK FOOTER //
// ./src/skeletons/modal.js